import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { Pressable } from "react-native";

export type ModuleViewMode = "list" | "grid";

type ModuleViewModeToggleProps = {
	value: ModuleViewMode;
	onValueChange: (value: ModuleViewMode) => void;
};

const VIEW_MODE_OPTIONS = [
	{
		value: "list" as const,
		icon: "format-list-bulleted",
		accessibilityLabel: "List view",
	},
	{
		value: "grid" as const,
		icon: "view-grid-outline",
		accessibilityLabel: "Grid view",
	},
] as const;

export const ModuleViewModeToggle = ({
	value,
	onValueChange,
}: ModuleViewModeToggleProps) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			style={{
				alignSelf: "flex-start",
				borderWidth: 1,
				borderColor: theme.colors.outline,
				borderRadius: theme.roundness,
				overflow: "hidden",
				backgroundColor: theme.colors.surface,
			}}
		>
			{VIEW_MODE_OPTIONS.map((option, index) => {
				const selected = option.value === value;

				return (
					<Pressable
						key={option.value}
						onPress={() => onValueChange(option.value)}
						accessibilityRole="button"
						accessibilityLabel={option.accessibilityLabel}
						accessibilityState={{ selected }}
						style={{
							width: 40,
							height: 32,
							alignItems: "center",
							justifyContent: "center",
							backgroundColor: selected
								? theme.colors.secondaryContainer
								: theme.colors.surface,
							borderLeftWidth: index === 0 ? 0 : 1,
							borderLeftColor: theme.colors.outline,
							// @ts-ignore web-specific affordance
							cursor: "pointer",
						}}
					>
						<Icon
							name={option.icon}
							size={18}
							color={selected ? theme.colors.primary : theme.colors.onSurface}
						/>
					</Pressable>
				);
			})}
		</Box>
	);
};
